import { capitalizeFirstLetter } from "utils/helper";

export const getField = (field, isTask) => {
  if (field === "customer") {
    return "CustomerId";
  } else if (field === "locationId" || field === "locationName") {
    if (isTask) {
      return "ServicePointId";
    }
    return "AssetId";
  } else if (field === "dispatcher") {
    return "DispatcherId";
  } else if (field === "fault") {
    return "Category";
  } else if (field === "faultDetails") {
    return "SubCategory";
  } else if (field === "secondaryAssignee") {
    return "SecondaryAssigneeId";
  } else if (field === "primaryAssignee") {
    return "AssigneeId";
  }
  return capitalizeFirstLetter(field);
};

export const getValueField = (field, isTask) => {
  let _field = field || "";
  if (_field === "customer") {
    _field = "customerId";
  } else if (_field === "locationId" || _field === "locationName") {
    if (isTask) {
      _field = "servicePointId";
    } else {
      _field = "assetId";
    }
  } else if (field === "vaultAccessRequired" && isTask) {
    return "vaultAccessRequiredValue";
  } else if (_field === "dispatcher") {
    return "dispatcherId";
  } else if (_field === "secondaryAssignee") {
    return "secondaryAssigneeId";
  } else if (_field === "primaryAssignee") {
    return "assigneeId";
  } else if (_field === "priority") {
    return "priorityId";
  }

  return _field;
};
